import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as actions from './actions';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class HaloCredsEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadMspHaloCreds),
            mergeMap(() =>
                this.ajax.get('/api/octiga/v3/msp/halo/creds').pipe(
                    map((res) => actions.loadMspHaloCredsSuccess(res)),
                    catchError((error) => of(actions.loadMspHaloCredsFailure({ error }))),
                ),
            ),
        ),
    );

    create$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.createMspHaloCreds),
            mergeMap(({ data }) =>
                this.ajax.post<{ valid: boolean }>('/api/octiga/v3/msp/halo/creds', data).pipe(
                    switchMap(({ valid }) =>
                        valid
                            ? this.ajax
                                  .get('/api/octiga/v3/msp/halo/creds')
                                  .pipe(mergeMap((creds) => [actions.createMspHaloCredsSuccess({ data: creds.data })]))
                            : throwError(() => new Error('Invalid credentials')),
                    ),
                    catchError((error) => of(actions.createMspHaloCredsFailure({ error }))),
                ),
            ),
        ),
    );

    put$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.putMspHaloCreds),
            mergeMap(({ data }) =>
                this.ajax.put<{ valid: boolean }>('/api/octiga/v3/msp/halo/creds', data).pipe(
                    switchMap(({ valid }) =>
                        valid
                            ? this.ajax
                                  .get('/api/octiga/v3/msp/halo/creds')
                                  .pipe(mergeMap((creds) => [actions.putMspHaloCredsSuccess({ data: creds.data })]))
                            : throwError(() => new Error('Invalid credentials')),
                    ),
                    catchError((error) => of(actions.putMspHaloCredsFailure({ error }))),
                ),
            ),
        ),
    );

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.deleteMspHaloIntegration),
            mergeMap(() =>
                this.ajax.delete('/api/octiga/v3/msp/halo').pipe(
                    map(() => actions.deleteMspHaloIntegrationSuccess()),
                    catchError((error) => of(actions.deleteMspHaloIntegrationFailure({ error }))),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
